/* eslint-disable formatjs/no-literal-string-in-jsx */
import PropTypes from 'prop-types';
import { MenuItem, Select } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import { ANCHORED_MENU_PROPS } from 'utils/muiSelectProps';

const DeviceField = ({
  icon,
  label,
  options,
  value = '',
  onChange,
  helpText,
  action = null,
  progress,
  disabled = false,
}) => {
  const fieldId = `device-${label.replace(/\s+/g, '-').toLowerCase()}`;
  const labelId = `${fieldId}-label`;
  const safeValue = options.some(option => option.value === value) ? value : '';

  return (
    <div className="vonage-device-field">
      <div className="vonage-device-field__header">
        <div id={labelId} className="vonage-device-field__label">
          {icon}
          <span>{label}</span>
        </div>
        {action}
      </div>
      <Select
        id={fieldId}
        labelId={labelId}
        className="vonage-device-field__select"
        variant="standard"
        value={safeValue}
        onChange={event => onChange(event.target.value)}
        disabled={disabled}
        displayEmpty
        disableUnderline
        IconComponent={ArrowDropDownIcon}
        MenuProps={{
          ...ANCHORED_MENU_PROPS,
          slotProps: {
            paper: { className: 'vonage-device-menu' },
            list: {
              className: 'vonage-device-menu__list',
              'aria-labelledby': labelId,
            },
          },
        }}
        renderValue={selectedValue => (
          <span className="vonage-device-field__selected-text">
            {options.find(option => option.value === selectedValue)?.label ||
              ''}
          </span>
        )}
      >
        {options.map(option => {
          const selected = option.value === safeValue;
          return (
            <MenuItem
              className="vonage-device-menu__option"
              key={option.value}
              value={option.value}
              selected={selected}
            >
              <CheckIcon
                aria-hidden="true"
                className={`vonage-device-menu__check${
                  selected ? ' is-selected' : ''
                }`}
              />
              <span>{option.label}</span>
            </MenuItem>
          );
        })}
      </Select>
      <span className="vonage-device-field__help">{helpText}</span>
      {progress !== undefined && (
        <div
          className={`vonage-device-field__meter${
            progress === 'critical' ? ' is-critical' : ''
          }`}
          role="progressbar"
          aria-label="Microphone input level"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={progress === 'critical' ? 0 : progress}
        >
          <span
            style={{
              width: `${
                progress === 'critical'
                  ? 1
                  : Math.max(0, Math.min(100, progress))
              }%`,
            }}
          />
        </div>
      )}
    </div>
  );
};

DeviceField.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  helpText: PropTypes.node.isRequired,
  action: PropTypes.node,
  progress: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
};

export default DeviceField;
